module.exports = __webpack_public_path__ + "img/jaye-kang-be-special.b8bd8ec.jpg";